import { render } from "./EditorAttachment.vue?vue&type=template&id=dbb23d00&ts=true"
import script from "./EditorAttachment.vue?vue&type=script&lang=ts"
export * from "./EditorAttachment.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__